<div
    [formGroup]="form"
    [hidden]="isHidden"
    [ngSwitch]="control.controlType"
    class="control-container"
    [class.stretched]="control.controlType === controltype.TextMultiLine"
>
    <!-- TextSingleLine -->
    <mat-form-field
        *ngSwitchCase="4"
        appearance="outline"
        class="cp-input cp-text-single-line se-form-field"
        [title]="control.icon ? '' : control.tooltip"
    >
        <mat-label *ngIf="control.isWithLabel">{{ control.name }}</mat-label>
        <input
            matInput
            type="text"
            class="se-form-field-input"
            autocomplete="off"
            [errorStateMatcher]="errorStateMatcher"
            [formControlName]="control.id"
            [placeholder]="control.isWithLabel ? control.name : ''"
            (focus)="onFocus()"
        />

        <mat-icon
            *ngIf="control.icon"
            matSuffix
            class="cp-suffix-icon"
            [title]="control.tooltip"
        >
            {{ control.icon }}
        </mat-icon>
        <mat-hint></mat-hint>
    </mat-form-field>

    <!-- TextMultiLine -->
    <mat-form-field
        *ngSwitchCase="5"
        appearance="outline"
        class="cp-input cp-text-multi-line se-form-field"
        [style.minHeight.px]="control.getHeight()"
        [title]="control.icon ? '' : control.tooltip"
    >
        <mat-label *ngIf="control.isWithLabel">{{ control.name }}</mat-label>
        <textarea
            matInput
            [errorStateMatcher]="errorStateMatcher"
            [formControlName]="control.id"
            [placeholder]="control.isWithLabel ? control.name : ''"
            (focus)="onFocus()"
        >
        </textarea>
    </mat-form-field>

    <!-- Duration -->
    <mat-form-field
        *ngSwitchCase="11"
        appearance="outline"
        class="cp-input cp-duration se-form-field"
        [title]="control.icon ? '' : control.tooltip"
    >
        <mat-label *ngIf="control.isWithLabel">{{ control.name }}</mat-label>
        <se-duration
            class="se-form-field-input"
            [format]="durationFormat"
            [formControlName]="control.id"
        ></se-duration>
        <mat-hint>{{durationLabel}}</mat-hint>
    </mat-form-field>

    <!-- Checkbox -->
    <mat-checkbox
        *ngSwitchCase="21"
        class="cp-input cp-checkbox"
        [formControlName]="control.id"
        (click)="onCheckboxAction()"
        (keydown.space)="onCheckboxAction()"
        (focusin)="onFocus()"
        [title]="control.name"
    >
        {{ control.name }}
    </mat-checkbox>

    <!-- ThreeStateCheckbox -->
    <mat-checkbox *ngSwitchCase="22"
                  class="cp-input cp-checkbox"
                  [formControlName]="control.id"
                  [indeterminate]="model === null"
                  (click)="onCheckboxAction(true)"
                  (keydown.space)="onCheckboxAction(true)"
                  (focusin)="onFocus()"
                  [title]="control.name">
        {{ control.name }}
    </mat-checkbox>

    <!-- Sconosciuto -->
    <h1 *ngSwitchDefault class="cp-unimplemented">
        Controllo di tipo input sconosciuto (type {{ control.controlType }}): {{ control.name || undefined }}
    </h1>
</div>
